<template>
	<v-container
	 fluid
   fill-height
   class="p-0"
	>
		<v-row  
		 align="center"
		 justify="center"		
     class="pa-0 fill-height"
		 :style="getBgColor(action)"
		>	
      <v-col
        id="text-canvas"         
        cols="12"
        class="text-center pa-0"
        v-show="actionType === 'text'"
      >        
          <ka-text  :text="actionValue"></ka-text>  
      </v-col>	 
		  <v-col 
        id="video-canvas" 		    
		    cols="12"
		    class="text-center pa-0 fill-height"
		    v-if="actionType === 'video'"
		  >		  						  	
		  		<ka-video :options="pOptions" :key="action.id" class="fill-height"></ka-video>  			    
		  </v-col>
      <v-col 
        id="image-canvas"         
        cols="12"
        class="text-center pa-0 fill-height"
        v-if="actionType === 'image'"
      >                     
          <ka-image :url="getMediaObject(action.type,actionValue)" :key="action.id" class="fill-height"></ka-image>            
      </v-col>
      <v-col 
        id="audio-canvas"         
        v-if="actionType === 'audio'"
      >                     
          <ka-audio :options="pOptions" :key="action.id"></ka-audio>            
      </v-col>	
		</v-row>		
	</v-container>
</template>

<script>
import KaText from './actions/Text.vue'
import KaVideo from './actions/VideoPlayer.vue'
import KaAudio from './actions/AudioPlayer.vue'
import KaImage from './actions/Image.vue'
import { emptyObject } from '../tools/helpers.js'

export default {
  name: 'Action',
  components: {
    KaText,
    KaVideo,
    KaAudio,
    KaImage
  },
  props: {
  	action: {
	    type: Object,
	    default() {
	        return null
	    }
    },
    // language:{
    //   type: String,
    //   default(){
    //     return 'default'
    //   }
    // },
    medias:{
    	type: Array,
	    default() {
	        return []
	    }
    }
  },
  data(){
  	return {
  		playerOptions: {
	        autoplay: true,
	        controls: false,
	        loop: true,
	        responsive: true,
	        sources: []
      	}
  	}
  },
  mounted(){
  	console.log("DEBUG Actions.vue mounted")
  },
  beforeUpdate(){
        console.log("DEBUG Actions.vue beforeUpdate")
    },
    updated(){
        console.log("DEBUG Actions.vue updated")
    },
  methods:{
    getMediaObject(type,url){
      let data = {} 
      data.src = url
      switch (type){          
        case 'audio':
          data.type = "audio/mp3"
          break
        case 'video':
          data.type = "video/mp4"
          break
        case 'image':
          data = data.src
          break
      }
      return data
  	},
  	// getMediaObject(mediaName){
  	// 	console.log(mediaName,this.medias)
    //   let data = {}
  	// 	let target = this.medias.find((media) => media.name == mediaName) 

    //   if (target == null)
    //     return ''
    //   else{
    //     data.src = target.content_url 
    //     switch (target.media_type){          
    //       case 'audio':
    //        data.type = "audio/mp3"
    //        break
    //       case 'video':
    //        data.type = "video/mp4"
    //        break
    //       case 'image':
    //        data = data.src
    //        break
    //     }
    //     return data
    //   }
  	// 	// return target == null ? '': [{src: target.content_url, type: "video/mp4"}]
  	// },
    getBgColor(act){
      return {
        'background-color': act.bgColorRemote
      }
    }
  },
  computed:{
  	actionType(){
  		return emptyObject(this.action) ? '' : this.action.type
  	},
  	actionValue(){
      console.log("DEBUG Actions.vue actionValue:", this.action)
      return emptyObject(this.action) ? '' : this.action.value[this.language]
  	},
  	actionLoop(){
      // console.log("XXX",emptyObject(this.action) ? '' : this.action.loop, this.action)
  		return emptyObject(this.action) ? '' : this.action.loop
  	},
    language(){
      return this.$store.state.language
    },
  	pOptions(){
  		let data = {}
  		this.playerOptions.loop = this.actionLoop
  		this.playerOptions.sources = this.getMediaObject(this.action.type,this.actionValue)

  		return this.playerOptions
  	},

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
